/**
 * Vendors
 */
import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Label, Input, FormGroup } from 'reactstrap';
import Countdown from 'react-countdown-now';
import cn from 'classnames';

/**
 * Helpers
 */
import { countDownRender, getPlaceholder } from './twoFactorAuthHelpers';

/**
 * Components
 */
import TwoFactorActivateBlockGuildeSms from './TwoFactorActivateBlockGuildeSms';
import TwoFactorActivateBlockGuildeGauth from './TwoFactorActivateBlockGuildeGauth';

/**
 * PropTypes
 */
const propTypes = {
  intl: intlShape.isRequired,
};

/**
 * Expo
 */
const TwoFactorActivateBlock = ({
  sessionId,
  validTill,
  error,
  status,
  two_factor,
  onSubmit,
  phone,
  intl,
}) => {
  const [code, setCode] = useState('');
  const [timestamp, setTimestamp] = useState(null);

  const onChange = ({ target }) => {
    const { value } = target;
    setCode(value);
  };

  const handleSubmit = () => {
    onSubmit(code);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const renderGuide = (type) => {
    switch (type) {
      case 1:
        return <TwoFactorActivateBlockGuildeSms phone={phone} />;

      case 2:
        return <TwoFactorActivateBlockGuildeGauth qr={two_factor.qr} />;

      default:
        return null;
    }
  };

  useEffect(() => {
    const timestamp = validTill * 1000;
    setTimestamp(timestamp);
  }, [validTill]);

  const isCountdownRendering = () => status !== 403 && Boolean(timestamp) && two_factor.type === 1;

  const secretKey =
    two_factor.qr && two_factor ? two_factor?.qr?.split('=')[1].split('&')[0] : null;

  console.log(two_factor.type);
  return two_factor.type !== 0 ? (
    <div className="two-factor-activate-block">
      <div className="two-factor-activate-form">
        {renderGuide(two_factor.type)}
        {secretKey && two_factor.type === 2 ? (
          <p>
            <FormattedMessage
              id="pages.profile.security.activate.keySettings"
              defaultMessage="Key settings"
              values={{ secretKey }}
            />
          </p>
        ) : null}
        <FormGroup className={cn("form-group-upper-label", { "has-error": error })}>
          <Label for="two-factor-activate-field">
            <FormattedMessage
              id="pages.profile.security.activate.label"
              defaultMessage="Confirmation code"
            />
          </Label>
          <Input
            name="code"
            id="two-factor-activate-field"
            required
            value={code}
            onChange={onChange}
            autoComplete="off"
            disabled={status === 403}
            autoFocus
            placeholder={getPlaceholder(intl, sessionId)}
            onKeyPress={handleKeyPress}
          />
          {error && <span className="sms-code-error">{error}</span>}
          {isCountdownRendering() && (
            <p className="session-timer-container">
              <Countdown date={timestamp} zeroPadTime={2} renderer={countDownRender} />
            </p>
          )}
        </FormGroup>
        <Button onClick={handleSubmit} color="primary" size="md" className="form-group-btn">
          <FormattedMessage id="main.confirm" defaultMessage="Confirm" type="button" />
        </Button>
      </div>
    </div>
  ) : null;
};

TwoFactorActivateBlock.propTypes = propTypes;

export default injectIntl(TwoFactorActivateBlock);
